import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-html",
  "use": "icon-html-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-html\"><path d=\"M123 234v550c0 78 63 141 141 141h496c78 0 141-63 141-141V350c0-78-63-141-141-141H583l-70-70c-12-12-28-19-45-19H264c-78 0-141 63-141 141v73z\" fill=\"#FFA000\" p-id=\"4426\" /><path d=\"M264 120h204c17 0 33 7 45 19l70 70h177c78 0 141 63 141 141v24H123v-73c0-78 63-141 141-141z\" fill=\"#FFCA28\" p-id=\"4427\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol